import $ from 'jquery'

$(document).ready(function () {
    $('select:not([multiple]').wrap('<div class="selection-wrapper">');

    $('.swatch-checkbox .wpcf7-list-item').each(function(){
        $(this).find('input').addClass('swatch-'+ $(this).find('input').val());
    });

    // Listen for change events on the checkboxes with class 'wpcf7-checkbox'
    $('.swatch-checkbox input[value="other"]').change(function () {  
        // Check if the 'other' checkbox is checked
        if ($(this).is(':checked')) {
            // Show the label with class 'wpcf7-list-item-label' for the 'other' checkbox
            $('.othercolors').removeClass('hide');
        } else {
            // Hide the label with class 'wpcf7-list-item-label' for the 'other' checkbox
            $('.othercolors').addClass('hide');
        }
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/inputs.js